<app-share-button ></app-share-button>
<div class="row">
    <div class="col-md-8 ScrollStyle-1">

        <div class="card crd p-3">
            <div class="row">
                <div class="col-md-10 col10 mt-2">
                    <h2>
                        <h2> How to create a Booking profile? </h2>
                    </h2>
                </div>

                <div class="col-md-2 col2"><a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
                    alt=""> </button> </a>
                </div>
                <!-- <div class="col-md-12" (mouseover)="showpayment(true,'1')"
                    (mouseout)="showpayment(false,'1')" id='59'>
                    <div
                        style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">

                        <iframe
                            class="i-frame"
                            src="https://www.youtube.com/embed/RLUj" title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div>
                </div> -->
                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'2')" (mouseout)="showpayment(false,'2')"
                    id='60'>
                    <h4>
                        How to create a Booking profile?

                    </h4>
                    <label for="" class="mt-3">Login to your PayG account.</label>

                    <div class="row">
                        <div class="col-md-12 text-center">
                            <img src="./assets/booking1.png" width="100%" height="100%" alt="">
                        </div>
                    </div>
                    <label for="" class="mt-4">On the left side of the dashboard,
                        click on “Booking
                        and Ticketing” feature.</label>

                    <div class="row">
                        <div class="col-md-12 text-center">
                            <img src="./assets/booking2.png" width="100%" height="100%" alt="">
                        </div>
                    </div>

                    <label for="" class="mt-3">On the top right corner of the
                        dashboard, click on
                        “Create new booking event” and select one of the options “Create booking
                        profile for venue event” or “Create booking profile for online
                        event”.</label>

                    <div class="row">
                        <div class="col-md-12 text-center">
                            <img src="./assets/booking3.png" width="100%" height="100%" alt="">
                        </div>
                        <div class="col-md-12 text-center">
                            <img src="./assets/booking4.png" width="100%" height="100%" alt="">
                        </div>
                    </div>
                    <label for="" class="mt-3">Next, choose a template or make your
                        own and fill in
                        all the information, including the profile name, category, organized by,
                        about the event, etc. You can add and remove as many fields as you want
                        because it is completely customizable. </label>

                    <div class="row mt-3">
                        <div class="col-md-12 text-center">
                            <img src="./assets/booking5.png" width="100%" height="100%" alt="">
                        </div>
                        <div class="col-md-12 mt-2 text-center">
                            <img src="./assets/booking6.png" width="100%" height="100%" alt="">
                        </div>
                    </div>

                    <label for="" class="mt-3">Moving to the next step, fill in the
                        details for
                        venue and time details.</label>

                    <div class="row mt-3">
                        <div class="col-md-12 text-center">
                            <img src="./assets/booking7.png" width="100%" height="100%" alt="">
                        </div>
                        <div class="col-md-12 mt-2 text-center">
                            <img src="./assets/booking8.png" width="100%" height="100%" alt="">
                        </div>
                        <div class="col-md-12 mt-2 text-center">
                            <img src="./assets/booking9.png" width="100%" height="100%" alt="">
                        </div>
                    </div>
                    <label for="" class="mt-3">Next, set customer type like
                        nationality, gender,
                        etc. Then select Create Ticket Services, where you can choose whether to
                        generate a single ticket or numerous tickets for your clients. Then enter
                        every other detail. If you choose the "Need only bookings" option, no
                        revenue will be made; it will merely serve as an admission ticket to the
                        event. Click "Create add-ons" if the merchant wants to offer their clients
                        other services.</label>


                    <div class="row mt-3">
                        <div class="col-md-12 text-center">
                            <img src="./assets/booking10.png" width="100%" height="100%" alt="">
                        </div>
                        <div class="col-md-12 mt-2 text-center">
                            <img src="./assets/booking11.png" width="100%" height="100%" alt="">
                        </div>
                        <div class="col-md-12 mt-2 text-center">
                            <img src="./assets/booking12.png" width="100%" height="100%" alt="">
                        </div>
                    </div>

                    <label for="" class="mt-3">"View Profile" is the next phase,
                        where you can
                        preview your profile before it is really seen by your clients.</label>

                    <div class="row mt-3">
                        <div class="col-md-12 text-center">
                            <img src="./assets/booking13.png" width="100%" height="100%" alt="">
                        </div>
                    </div>
                    <label for="" class="mt-3">The last step is to “Create ticket”.
                        Copy the link
                        generated or download the QR code and share it with your customers.</label>

                    <div class="row mt-3">
                        <div class="col-md-12 text-center">
                            <img src="./assets/booking14.png" width="100%" height="100%" alt="">
                        </div>
                    </div>
                    <label for="" class="mt-3">In conclusion, setting up a booking
                        and ticketing
                        profile within PayG is a straightforward process that empowers you to
                        seamlessly manage reservations and transactions. By following the steps
                        outlined above, you'll be well on your way to creating a robust profile that
                        caters to your business's unique needs. Remember that a well-configured
                        booking and ticketing profile not only streamlines your operations but also
                        enhances customer satisfaction, leading to increased trust and loyalty.
                        Should you encounter any challenges during the setup process, our dedicated
                        support team is readily available to assist you. Thank you for choosing PayG
                        for your booking and ticketing needs – we look forward to contributing to
                        your business's success.</label>


                </div>
            </div>
        </div>
    </div>
    <div class="col-md-4  hide-tbl content2 ">
        <div class="card crd p-4">
            <div class="row">
                <div class="col-md-12">
                    <h5>
                        Table of Contents:
                    </h5>

                </div>
                <div class="col-md-12 mt-2">
                    <!-- <a href="#59">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                                    alt=""> &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="videoHover"
                                    [ngClass]="{'video':colors=='1'}" (click)="color('1')">
                                   
Creating Booking and Ticketing Profile
</span>
                            </div>
                        </div>
                    </a> -->
                </div>

                <div class="col-md-12 mt-3">
                    <a href="#60">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='2'}"
                                    (click)="color('2')">

                                    Creating Booking and Ticketing Profile
                                </span>

                            </div>
                        </div>
                    </a>
                </div>

            </div>
        </div>
    </div>
    <div class="col-md-9 hide ft-9">
        <hr>    
        <div class=" row crd">
            <div class="col-md-8">
                <a [routerLink]="['/booking-tecketing']"> <button class="btn btn-color"
                    >
                    <img src="./assets/Arrow 3.svg" alt="">&nbsp;&nbsp;Booking &
                    Ticketing
                </button>
            </a>
              
            </div>
            <!-- <div class="col-md-4    ">
                <a [routerLink]="['/pay-out']">   <button class="btn  btn-color"  >Pay out
                    &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>
            </div> -->
            <div class="col-md-4    ">
                <a [routerLink]="['/onboarding']">   <button class="btn  btn-color"  >Onboarding
                    &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>
            </div>

        </div>
    </div>
</div>